import { createApp } from 'vue'
import App from './Chart.vue'
createApp(App).mount('#tv_app')